export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access-token-lobby',
  SAVED_CREDENTIALS: 'saved-credentials',
  CURRENT_USER_ID: 'current-user-id',
} as const;

// Type for the keys
export type LocalStorageKey = keyof typeof LOCAL_STORAGE_KEYS;
